var render = function render(){
  var _vm$netProfit_perItem, _vm$netProfit_perItem2, _vm$netProfit_overall, _vm$netProfit_overall2, _vm$percentage_margin, _vm$percentage_margin2, _vm$breakeven_selling, _vm$breakeven_selling2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('mypage-layout', {
    attrs: {
      "title": "마진 시뮬레이터"
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "label": "판매가 (권장가 대비  ± 10% 범위 내로만 입력 가능)"
    },
    model: {
      value: _vm.salePrice,
      callback: function ($$v) {
        _vm.salePrice = $$v;
      },
      expression: "salePrice"
    }
  }, 'v-currency-field', _vm.attrs_input2, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "label": "공급가"
    },
    model: {
      value: _vm.cost,
      callback: function ($$v) {
        _vm.cost = $$v;
      },
      expression: "cost"
    }
  }, 'v-currency-field', _vm.attrs_input2, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('margin-commission', {
    model: {
      value: _vm.commission,
      callback: function ($$v) {
        _vm.commission = $$v;
      },
      expression: "commission"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('margin-isconsigned', {
    model: {
      value: _vm.isConsigned,
      callback: function ($$v) {
        _vm.isConsigned = $$v;
      },
      expression: "isConsigned"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "label": "택배비"
    },
    model: {
      value: _vm.deliveryCharge,
      callback: function ($$v) {
        _vm.deliveryCharge = $$v;
      },
      expression: "deliveryCharge"
    }
  }, 'v-currency-field', _vm.attrs_input2, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "label": "기타비용"
    },
    model: {
      value: _vm.otherExpenses,
      callback: function ($$v) {
        _vm.otherExpenses = $$v;
      },
      expression: "otherExpenses"
    }
  }, 'v-currency-field', _vm.attrs_input2, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-currency-field', _vm._b({
    attrs: {
      "label": "판매수량"
    },
    model: {
      value: _vm.quantity,
      callback: function ($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  }, 'v-currency-field', _vm.attrs_input2, false))], 1)], 1), _c('v-btn', {
    staticClass: "mt-4 mt-md-6",
    attrs: {
      "block": "",
      "color": "primary",
      "x-large": ""
    },
    on: {
      "click": _vm.calc
    }
  }, [_vm._v("결과 도출")])], 1), _c('v-sheet', {
    staticClass: "pa-4 pa-md-6 text-center",
    attrs: {
      "color": "grey lighten-5",
      "rounded": "xl"
    }
  }, [_c('v-row', {
    staticClass: "results",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "xl": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("건당 순이익")]), _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('span', {
    staticClass: "tit--xxs font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$netProfit_perItem = _vm.netProfit_perItem) === null || _vm$netProfit_perItem === void 0 ? void 0 : (_vm$netProfit_perItem2 = _vm$netProfit_perItem.format) === null || _vm$netProfit_perItem2 === void 0 ? void 0 : _vm$netProfit_perItem2.call(_vm$netProfit_perItem)) || 0))]), _c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v("원")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "xl": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("총 순이익")]), _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('span', {
    staticClass: "tit--xxs font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$netProfit_overall = _vm.netProfit_overall) === null || _vm$netProfit_overall === void 0 ? void 0 : (_vm$netProfit_overall2 = _vm$netProfit_overall.format) === null || _vm$netProfit_overall2 === void 0 ? void 0 : _vm$netProfit_overall2.call(_vm$netProfit_overall)) || 0))]), _c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v("원")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "xl": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("마진율")]), _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('span', {
    staticClass: "tit--xxs font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$percentage_margin = _vm.percentage_margin) === null || _vm$percentage_margin === void 0 ? void 0 : (_vm$percentage_margin2 = _vm$percentage_margin.format) === null || _vm$percentage_margin2 === void 0 ? void 0 : _vm$percentage_margin2.call(_vm$percentage_margin, 2)) || 0))]), _c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v("%")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "xl": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_vm._v("순익분기 판매가")]), _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('span', {
    staticClass: "tit--xxs font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$breakeven_selling = _vm.breakeven_selling) === null || _vm$breakeven_selling === void 0 ? void 0 : (_vm$breakeven_selling2 = _vm$breakeven_selling.format) === null || _vm$breakeven_selling2 === void 0 ? void 0 : _vm$breakeven_selling2.call(_vm$breakeven_selling)) || 0))]), _c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v("원")])])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }